<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] WO Progressing
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <!-- <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (header && header.Status_Closing != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status_Closing != this.$APPROVAL_STATUS.APPROVED && header.Status_Closing != this.$APPROVAL_STATUS.REVISED)"/> -->
                        <Button icon="pi pi-upload" label="Send to Work Group Execution" class="p-button-help" @click="confirmExecution($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && this.isSendCLosingExecution" />
                        
                        <Button icon="pi pi-upload" label="Save Progress" class="p-button-success mr-2" @click="confirm($event)" v-if="(header && header.Status_Closing != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status_Closing != this.$APPROVAL_STATUS.CLOSED) && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && !this.isSendCLosingExecution" />
                        
                        <!-- <Button icon="pi pi-upload" label="Save" class="p-button-success mr-2" @click="confirm($event, true)" v-if="(header && header.Status_Closing == this.$APPROVAL_STATUS.CLOSED) && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && this.$store.getters.getIsUpdateWo" /> -->
                        
                         <Button icon="pi pi-upload" label="Submit" class="p-button-warning" @click="confirmSubmit($event)" v-if="(header && header.Status_Closing != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status_Closing != this.$APPROVAL_STATUS.CLOSED) && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && !this.isSendCLosingEng && !this.isSendCLosingExecution" />
                        <!-- && (header && header.NIK_PIC_Closing == this.$store.getters.getUsername) -->
                        <Button icon="pi pi-upload" label="Update Detail" class="p-button-secondary mr-2" @click="confirmUpdateDetail($event)" v-if="mode == this.$FORM_MODE_VIEW && !this.isSendCLosingEng && !this.isSendCLosingExecution" />
                        
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger mr-2" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <Button icon="pi pi-file-pdf p-button-icon" v-show="mode == this.$FORM_MODE_VIEW" class="p-button p-component p-button-icon-only p-button-rounded p-button-danger p-button-outlined mr-2"
                            @click="generatePdf(header)"  target="_blank"/>

                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">

                            <FormField :labelName="$t('no_wo')" fieldName="Wo_Number" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="no_wo" v-model="header.Wo_Number" required="true" type="text"
                                    :placeholder="$t('no_wo')" v-if="header"
                                    :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t(labelNIKClosing)" fieldName="NIK_PIC_Closing" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="this.header && (this.header.Category == this.$CategoryWo.Engineering || this.header.Category == this.$CategoryWo.Drafter || this.header.Category == this.$CategoryWo.NON_PROJECT_ENGINEERING)">
                                <CustomSelect name="NIK_PIC_Closing" :filter="true"  v-if="header"
                                    v-model="header.NIK_PIC_Closing" required="true" 
                                    placeholder="Please Select"
                                    :url="$API_URL + 'list/usernameWilmar'"
                                    :minLength="0"

                                    :params="{ job_postion:apprAsNIKClosing, companycode : header.Company_Code, contractorcode : header.Contractor_Code, locationcode : this.header.Location_Code}" 
                                    :disabled=" (mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT) || (!isSendCLosingEng && header.NIK_PIC_Send != header.NIK_PIC_Closing)"/>
                                    <small v-if="header && !header.NIK_PIC_Closing && isSendCLosingEng && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t(labelNIKClosing)) }}
                                </small>
                            </FormField>
                            
                            <FormField :labelName="$t('Planned_Start_Date')" fieldName="Planned_Start_Date" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="Planned_Start_Date" v-model="header.Planned_Start_Date" type="text"
                                :placeholder="$t('Planned_Start_Date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="true"/>
                                <small
                                    v-if="header && !header.Planned_Start_Date && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('Target_Date')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('Planned_Finish_Date')" fieldName="Planned_Finish_Date" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="Planned_Finish_Date" v-model="header.Planned_Finish_Date" type="text"
                                :placeholder="$t('Planned_Finish_Date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="true"/>
                                <small
                                    v-if="header && !header.Planned_Finish_Date && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('Planned_Finish_Date')) }}
                                </small>
                            </FormField>
                            
                            
                            <FormField :labelName="$t('Act_Start_Date')" fieldName="Act_Start_Date" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="Act_Start_Date" v-model="header.Act_Start_Date" type="text"
                                :placeholder="$t('Act_Start_Date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY" @date-select="onStartWork()"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || (isSendCLosingExecution || isSendCLosingEng) || header.Status_Closing == this.$APPROVAL_STATUS.CLOSED"/>
                                <small
                                    v-if="header && (!header.Act_Start_Date && (!isSendCLosingExecution && !isSendCLosingEng)) && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('Act_Start_Date')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('Act_Finish_Date')" fieldName="Act_Finish_Date" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="Act_Finish_Date" v-model="header.Act_Finish_Date" type="text"
                                :placeholder="$t('Act_Finish_Date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY" @date-select="onFinishWork()"
                                :disabled="true"/>
                                <!-- mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT -->
                                <!-- <small
                                    v-if="header && !header.Finish_Work && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('Finish_Work')) }}
                                </small> -->
                            </FormField>

                            <FormField :labelName="$t('Remark')" fieldName="Remark" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <Textarea name="Remark" v-model="header.Remark" required="true" type="text"
                                    :placeholder="$t('Remark')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || (isSendCLosingExecution || isSendCLosingEng) || header.Status_Closing == this.$APPROVAL_STATUS.CLOSED" autoResize />
                                    <small v-if="header && (!header.Remark && ((!isSendCLosingExecution && !isSendCLosingEng)) && (this.header.Category == this.$CategoryWo.Admin_AR || this.header.Category == this.$CategoryWo.Drafter)) && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('Remark')) }}
                                     </small>
                            </FormField>

                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (header.Status_Closing == this.$APPROVAL_STATUS.CLOSED)">
                                <InputText name="Reason" v-model="header.Reason" required="true" type="text"
                                    :placeholder="$t('reason')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT && mode != this.$FORM_MODE_DELETE || (header.Status_Closing != this.$APPROVAL_STATUS.CLOSED)"/>
                                    <small v-if="header &&((!header.Reason && (header.Status_Closing == this.$APPROVAL_STATUS.CLOSED || mode == this.$FORM_MODE_DELETE) )) && submitted"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                    </small>
                            </FormField>

                        </div>  
                        <div class="col-6">
                            
                            <FormField :labelName="$t('status')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header">
                                <InputText name="Status" v-model="header.Status" required="true" type="text"
                                    :placeholder="$t('status')" v-if="header"
                                    :disabled="true" />                                    
                            </FormField>

                            <FormField :labelName="$t('By_Engineering')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && this.header.Category == this.$CategoryWo.Execution">
                              
                            </FormField>

                            <FormField :labelName="$t('Result')" fieldName="Result" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && this.header.Category == this.$CategoryWo.Execution">
                                <Textarea name="Remark" v-model="header.Remark_Closing" required="true" type="text"
                                    :placeholder="$t('Result')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || !isSendCLosingExecution" autoResize />
                                    <small v-if="header && (!header.Remark_Closing && isSendCLosingExecution) && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('Result')) }}
                                     </small>
                            </FormField>

                            
                            <FormField :labelName="$t('Attachment')" :fileModels="header.files_data" v-if="header && this.header.Category == this.$CategoryWo.Execution" labelClass="col-4" fieldClass="col-6">
                                <CustomFileUpload
                                    :fileModels="viewFiles"
                                    :multiple="true" 
                                    :showUploadButton="false" 
                                    :showCancelButton="false" 
                                    :customUpload="false" 
                                    @select="onFileSelectClosing" 
                                    @remove="onFileRemoveClosing" 
                                    :viewOnly="true" 
                                    :showHeader="false"
                                    @download="onDownloadFileClosing"
                                    />                                   
                            </FormField>
                        
                            <FormField :labelName="''" :fileModels="header.files_data1" v-model="header" v-if="header && this.header.Category == this.$CategoryWo.Execution" fieldClass="col-6" labelClass="col-4">
                                <CustomFileUpload 
                                :fileModels="header.files_data1"
                                :maxFileSize="5242880"
                                :multiple="true" 
                                :showUploadButton="false"
                                :showCancelButton="false" 
                                :customUpload="false" 
                                accept="image/*,.xlsx,.xls,.pdf,.zip,.doc,.docx"
                                @select="onFileSelectClosing($event, header)"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || !isSendCLosingExecution"
                                @remove="onFileRemoveClosing($event, header)" />
                            </FormField>

                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && ((header.Status == this.$APPROVAL_STATUS.IN_PROGRESS && header.isUpdateStatus) || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_REVISION)">
                                <InputText name="Reason" v-model="header.Reason" required="true" type="text"
                                    :placeholder="$t('reason')" v-if="header"
                                    :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT && mode != this.$FORM_MODE_DELETE || (header.Status != this.$APPROVAL_STATUS.IN_PROGRESS && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_REVISION))"/>
                                    <small v-if="header && !header.Reason && (header.Status == this.$APPROVAL_STATUS.IN_PROGRESS || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_REVISION) && submitted"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                    </small>
                            </FormField>

                        </div>
                        
                        <div class="col-12">
                            <!-- --!isSendCLosingExecution && !isSendCLosingEng -->
                            <DataTable v-if="header" :loading="!header" :value="header.Details ? header.Details : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table" :style="isSendCLosingExecution || isSendCLosingEng ? { opacity: 0.5, pointerEvents: 'none'} : {}">
                                <template #header>
                                    <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                                        <span class="text-900 font-bold">Progressing</span>
                                    </div>
                                </template>
                                <Column :exportable="false" style="width:30px">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetail()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || header.Status_Closing == this.$APPROVAL_STATUS.CLOSED" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                            @click="deleteDetail(slotProps)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || (slotProps.data.mode != this.$FORM_MODE_CREATE)"
                                            v-show="slotProps.data.mode != 'Delete'" />
                                    </template>
                                </Column>

                                <Column field="Progress" :header="$t('Progress')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">

                                        <InputNumber  mode="decimal"
                                            name="Act_Date" v-model="slotProps.data[slotProps.column.props.field]" :placeholder="$t('Progress')" @input="onCellEditComplete(slotProps)"
                                            :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || (slotProps.data.mode != this.$FORM_MODE_CREATE)) && this.header.Status_Closing != this.$APPROVAL_STATUS.WAITING_FOR_REVISION"
                                            :useGrouping="false" v-show="slotProps.data.mode != 'Delete'"  
                                            :max="100" :maxFractionDigits="2" style="width:150px;"/>

                                        </div>
                                    </template>
                                </Column>

                                <Column field="Is_show_Print" :header="$t('show_when_print')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">

                                        <Checkbox name="Is_show_Print" v-model="slotProps.data[slotProps.column.props.field]" :placeholder="$t('date')" @click.stop="onCellEditComplete(slotProps)"
                                            :binary="true" :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT && mode != this.$FORM_MODE_VIEW || header.Status_Closing == this.$APPROVAL_STATUS.CLOSED" :useGrouping="false"  v-show="slotProps.data.mode != 'Delete'"/>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Picture_Before" :header="$t('Picture_Before')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                                <CustomFileUpload 
                                                :fileModels="slotProps.data.files_data1"
                                                :multiple="false" 
                                                :showUploadButton="false"
                                                :showCancelButton="false" 
                                                :customUpload="false" 
                                                accept="image/*"
                                                :maxFileSize="5000000"
                                                @select="onFileSelect1($event, slotProps.data)"
                                                :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || (slotProps.data.mode != this.$FORM_MODE_CREATE))
                                                    && (this.header.Status != this.$APPROVAL_STATUS.WAITING_FOR_REVISION && this.header.Status != this.$APPROVAL_STATUS.IN_PROGRESS)"
                                                @remove="onFileRemove1($event, slotProps.data)"
                                                @change="onCellEditComplete(slotProps)"
                                                @input="onCellEditComplete(slotProps)" 
                                                v-show="slotProps.data.mode != 'Delete'"/>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="viewFiles1" :header="$t('download_before')" Key="Id" style="width:20px;">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <CustomFileUpload
                                            :fileModels="slotProps.data.viewFiles1"
                                            :multiple="false" 
                                            :showUploadButton="false" 
                                            :showCancelButton="false" 
                                            :customUpload="false" 
                                            @select="onFileSelect" 
                                            @remove="onFileRemove" 
                                            :viewOnly="true" 
                                            :showHeader="false"
                                            @download="onDownloadFile1"
                                            v-show="slotProps.data.mode != 'Delete'"
                                            />                        
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Picture_After" :header="$t('Picture_After')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                                <CustomFileUpload 
                                                :fileModels="slotProps.data.files_data"
                                                :multiple="false" 
                                                :showUploadButton="false"
                                                :showCancelButton="false" 
                                                :customUpload="false" 
                                                accept="image/*"
                                                :maxFileSize="5242880"
                                                @select="onFileSelect($event, slotProps.data)"
                                                :disabled="(mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || (slotProps.data.mode != this.$FORM_MODE_CREATE)) && 
                                                (this.header.Status != this.$APPROVAL_STATUS.WAITING_FOR_REVISION && this.header.Status != this.$APPROVAL_STATUS.IN_PROGRESS)"
                                                @remove="onFileRemove($event, slotProps.data)"
                                                @change="onCellEditComplete(slotProps)"
                                                @input="onCellEditComplete(slotProps)" 
                                                v-show="slotProps.data.mode != 'Delete'"
                                                />
                                        </div>
                                    </template>
                                </Column>
                               
                                <Column field="viewFiles2" class="" :header="$t('download_after')" Key="Id" style="width:20px;">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <CustomFileUpload
                                            :fileModels="slotProps.data.viewFiles2"
                                            :multiple="false" 
                                            :showUploadButton="false" 
                                            :showCancelButton="false" 
                                            :customUpload="false" 
                                            @select="onFileSelect" 
                                            @remove="onFileRemove" 
                                            :viewOnly="true" 
                                            :showHeader="false"
                                            @download="onDownloadFile2"
                                            v-show="slotProps.data.mode != 'Delete'"
                                            />                        
                                        </div>
                                    </template>
                                </Column>
                                

                            </DataTable>
                        </div>
                        <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                            <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('release_approval')">
                                    <ChangeHistory angeHistory v-if="this.header" :modelValue="this.dataModelRelease"
                                        :dataRequestLog="this.dataRelease" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode" :tableName="'WorkOrderClosing'"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
import moment from 'moment';
export default {
    name: "Editor",
    data() {
        return {
            indexName: "WoProgressingIndex",
            url: this.$API_URL + "WoProgressing/",
            header: null,
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            mainid : 0,
            formEditable: true,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            dataModelRelease: [],
            dataRelease: this.$dataRelease,
            viewFiles : null,
            participant : null,
            inspection : null,
            detailLog : null,
            dataChangesLog:this.$dataChangesLog,
            isSendCLosingEng : true,
            isSendCLosingExecution : false,
            labelNIKClosing : "",
            apprAsNIKClosing : ""
        }
    },
    methods: {
        updateWo() {
            this.$emit('block-ui');
            var self = this;
            this.$axios.post(this.url +"updatewo", this.header)
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: "Wo Progressing has been deleted successfully", life: 3000 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Wo Progressing has been saved successfully", life: 3000 } });
                        }

                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        generatePdf(model){
            this.$emit('block-ui');
            var self = this;
            model.valueLink = this.$store.getters.getUrlApp + this.$route.fullPath;
            model.signby = `${this.$DOCUMENTFOOTER.APPROVED_GENERATED} (Document Print by ${this.$store.getters.getFullname} at ${this.$formatDateTime2(new Date())}) ${ model !=null && model.Rev != 0 ? '- Document Rev ' + model.Rev : ""}`;
            
            this.$axios.post(this.$API_URL + "WoProgressing/" + "downloadprint", model,{
            responseType: 'blob',
            timeout: this.$AXIOS_TIMEOUT_LONG
            })
            .then((response) => {
                //let fileName = response.headers["content-disposition"].split("filename=")[1].split(";")[0];
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
            })
            .catch(function (err) {
                self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                self.blocked = false;
            })
            .finally(() => {
                self.$emit('unblock-ui');
            });
        },  
        getData() {
            var self = this;
            this.$axios.get(this.url + this.id + "/" + this.mode)
                .then((response) => {
                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.dataModelRelease = response.data.data.header.approval_log;
                    self.detail = response.data.data.detail;
                    self.detailLog = self.header.DetailLog;
                    this.isSendCLosingEng = this.header && this.header.NIK_PIC_Send ==  this.$store.getters.getUsername && (this.header.Category == this.$CategoryWo.Engineering || this.header.Category == this.$CategoryWo.Drafter) && (this.header.NIK_PIC_Send !=  this.header.NIK_PIC_Closing);
                    this.isSendCLosingExecution = this.header && this.header.NIK_PIC_Send ==  this.$store.getters.getUsername && this.header.Category == this.$CategoryWo.Execution && this.header.Work_Group == this.$WorkGroup.Project_Engineering;
                    if(self.mode == this.$FORM_MODE_CREATE)
                        self.header.Department_Code = this.$store.getters.getDepartmentWo;

                        if(self.header.Attachment_Closing){
                            var attachment = this.header.Attachment_Closing.split(';');
                            self.viewFiles = [];
                            attachment.forEach(a => {
                                if (a != '') {
                                    var name = a.split("/").at(-1);
                                    var d = {
                                        name: name,
                                        url: a,
                                        id: self.header.Id
                                    };

                                    self.viewFiles.push(d);
                                }
                            });
                        }


                        let listAppr = response.data.data.listPicAppr1;
                        if(listAppr.length > 0)
                        {
                            listAppr.forEach(a=>{
                                //if(a.Sign_Position == 2){
                                    self.labelNIKClosing = a.Approval_As;
                                    self.apprAsNIKClosing = a.Approval_As;
                                  //}
                               
                            });
                        }
                 
                })
                .catch(function (error) {
                    self.showError("Error", error);
                });
        },
        onStartWork(){
            var targetDate = new Date(this.header.Target_Date)
            var startWork = new Date(this.header.Start_Work)
            if(startWork > targetDate){
                this.header.Start_Work = null;
                this.showError('Error', "Start Work greather than Target Date");
            }
        },
        onFinishWork(){
            var targetDate = new Date(this.header.Target_Date)
            var startWork = new Date(this.header.Start_Work)
            var finishWork = new Date(this.header.Finish_Work)
            if(finishWork < targetDate){
                this.header.Finish_Work = null;
                this.showError('Error', "Finish Work smaller than Target Date");
            }
            if(finishWork < startWork){
                this.header.Finish_Work = null;
                this.showError('Error', "Finish Work smaller than Start Work");
            }
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;
            var data = new FormData();

            data.append("Id", this.header.Id);
            if(this.header.Wo_Number != null)
                data.append("Wo_Number", this.header.Wo_Number); 
            
            if(this.header.Status != null)
                data.append("Status", this.header.Status);
            
            if(this.header.Company_Code != null)
            data.append("Company_Code", this.header.Company_Code);

            if(this.header.Company_Area_Id != null)
            data.append("Company_Area_Id", this.header.Company_Area_Id);
        
            if(this.header.Department_Code != null)
            data.append("Department_Code", this.header.Department_Code);

            if(this.header.WBS_Allocation != null)    
            data.append("WBS_Allocation", this.header.WBS_Allocation);
            
            if(this.header.Work_Group != null)
            data.append("Work_Group", this.header.Work_Group);
        
            if(this.header.No_SPR != null)
                data.append("No_SPR", this.header.No_SPR);
            if(this.header.No_SPO !=null)
                data.append("No_SPO", this.header.No_SPO);
            if(this.header.No_SPK !=null)
                data.append("No_SPK", this.header.No_SPK);

            if(this.header.Work_Description)
                data.append("Work_Description", this.header.Work_Description);
            
            if(this.header.Remark)
                data.append("Remark", this.header.Remark);
            
            if(this.header.Remark_Closing)
                data.append("Remark_Closing", this.header.Remark_Closing);
            
            if(this.header.Duration)
                data.append("Duration", this.header.Duration);

            data.append("is_submit", this.header.is_submit);
            data.append("is_submit_execution", this.header.is_submit_execution);
            
            if(this.header.Planned_Start_Date)
                data.append("Planned_Start_Date1",moment(this.header.Planned_Start_Date).format('YYYY/MM/DD').toString());
            if(this.header.Planned_Finish_Date != null)
                data.append("Planned_Finish_Date1",moment(this.header.Planned_Finish_Date).format('YYYY/MM/DD').toString());
            
            if(this.header.Act_Start_Date != null)
                data.append("Act_Start_Date1",moment(this.header.Act_Start_Date).format('YYYY/MM/DD').toString());
            if(this.header.Act_Finish_Date != null)
                data.append("Act_Finish_Date1",moment(this.header.Act_Finish_Date).format('YYYY/MM/DD').toString());

            if(this.header.Usrnm_PM_Closing != null)
                data.append("Usrnm_PM_Closing", this.header.Usrnm_PM_Closing);
            if(this.header.Usrnm_Lead_Engineering !=null)
                data.append("Usrnm_Lead_Engineering", this.header.Usrnm_Lead_Engineering);
            if(this.header.Usrnm_Head_Project_Dept !=null)
                data.append("Usrnm_Head_Project_Dept", this.header.Usrnm_Head_Project_Dept);
            if(this.header.Usrnm_PIC_Engineering_Closing !=null)
                data.append("Usrnm_PIC_Engineering_Closing", this.header.Usrnm_PIC_Engineering_Closing);
            if(this.header.NIK_PIC_Closing !=null)
                data.append("NIK_PIC_Closing", this.header.NIK_PIC_Closing);
            if(this.header.Usrnm_Head_Project_Dept_Closing !=null)
                data.append("Usrnm_Head_Project_Dept_Closing", this.header.Usrnm_Head_Project_Dept_Closing);
            if(this.header.Usrnm_PM_Closing != null)
                data.append("Usrnm_PM_Closing", this.header.Usrnm_PM_Closing);
            if(this.header.Usrnm_Head_User_Closing != null)
                data.append("Usrnm_Head_User_Closing", this.header.Usrnm_Head_User_Closing);
            if(this.header.Usrnm_PIC_AR_Closing != null)
                data.append("Usrnm_PIC_AR_Closing", this.header.Usrnm_PIC_AR_Closing);
            if(this.header.Reason != null)
                data.append("Reason", this.header.Reason);


            data.append("Is_Old_Data", this.header.Is_Old_Data);

            data.append("mode", this.header.mode);

            if(this.category){
                data.append("Category", this.category);
            }
            
            //attach file
            if(this.header.files_data1 != null)
                for(var k=0; k < this.header.files_data1.length;k++){
                    var file = this.header.files_data1[k];
                    data.append("attachments1.File", file, file.name);
            }


            for(var j=0; j< this.header.Details.length;j++){
                var detail = this.header.Details[j];
                if(detail.mode != null)
                    data.append("Details[" + j + "].mode", detail.mode);
                if(detail.Id != null)
                    data.append("Details[" + j + "].Id", detail.Id);
                if(detail.Work_Order_Id != null)
                    data.append("Details[" + j + "].Work_Order_Id", detail.Work_Order_Id);
                if(detail.Progress != null){
                    data.append("Details[" + j + "].Progress_String", detail.Progress);
                    data.append("Details[" + j + "].Progress", detail.Progress);
                }

                if(detail.Is_show_Print != null)
                    data.append("Details[" + j + "].Is_show_Print", detail.Is_show_Print);

                if(detail.files_data1 != null){
                    for(var z=0; z < detail.files_data1.length;z++){
                        var file1 = detail.files_data1[z];
                        data.append("Details[" + j + "].attachments1.File", file1, file1.name);
                    } 
                }

                if(detail.files_data != null){
                    for(var x=0; x < detail.files_data.length;x++){
                        var file = detail.files_data[x];
                        data.append("Details[" + j + "].attachments.File", file, file.name);
                    }
                }   
            }
          
            this.$axios.post(this.url, data, 
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: "Wo Progressing has been deleted successfully", life: 3000 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Wo Progressing has been saved successfully", life: 3000 } });
                        }

                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
            else 
              this.$router.push({ path: "Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirmUpdateDetail(event) {
            this.submitted = true;
    
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure to update detail?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        confirmExecution(event){

            this.submitted = true;
            var self = this;
            this.header.is_submit_execution = true;
            if(!this.header.Remark_Closing && this.isSendCLosingExecution)
                return;
          
           
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Already confirm with Project Manager ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
        },
        confirmSubmit(event) {
            this.submitted = true;
            var self = this;
            this.header.is_submit = true;
            if(this.validationFromField() || (this.header && !this.header.Reason && this.header.Status == this.$APPROVAL_STATUS.IN_PROGRESS && this.header.isUpdateStatus) || (this.header && !this.header.Reason && this.header.Status == this.$APPROVAL_STATUS.WAITING_FOR_REVISION))
                return false;
           
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure to submit?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        confirm(event, isupdatewo = false) {
            this.submitted = true;
            var self = this;
            this.header.is_submit = false;
            if(this.validationFromField() || (this.header.Status_Closing == this.$APPROVAL_STATUS.CLOSED && !this.header.Reason))
                return false;
           
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(!isupdatewo)
                        this.saveData();
                    else 
                        this.updateWo();
                },
                reject: () => {

                }
            });
            
        },
        confirmDraft(event) {
            this.submitted = true;
            var self = this;
            this.header.is_submit = false;
            if(this.validationFromField())
                return;
          
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure save as draft ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(this.mode == this.$FORM_MODE_CREATE)
                        this.header.mode = this.$FORM_MODE_DRAFT;
                    else if(this.mode == this.$FORM_MODE_EDIT)
                        this.header.mode = this.$FORM_MODE_DRAFT_EDIT;
                    else
                        this.header.mode = this.mode;
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        validationFromField(){
           //!this.header.Target_Reschedule || 
           //|| !this.header.Finish_Work
           //!this.header.Remark ||
            if ( (!this.header.Act_Start_Date && (!this.isSendCLosingExecution && !this.isSendCLosingEng)) || !this.header.Planned_Finish_Date || !this.header.Planned_Start_Date || (!this.header.NIK_PIC_Closing && this.isSendCLosingEng) 
                || (!this.header.Remark && (!this.isSendCLosingExecution && !this.isSendCLosingEng) && (this.header.Category == this.$CategoryWo.Admin_AR || this.header.Category == this.$CategoryWo.Drafter)) || (!this.header.Remark_Closing && this.isSendCLosingExecution) ) {
                return true;
            }
            else{
                if((this.header.Category == this.$CategoryWo.Admin_AR || this.header.Category == this.$CategoryWo.Drafter) && this.header.Remark && this.header.Remark.length < 20){
                    this.showError("Error", "Remark minimal 20 character")
                    return true;
                }
                if(this.header.Details.length == 0 && !this.isSendCLosingEng && !this.isSendCLosingExecution){
                    this.showError("Error", "Must have one Progressing")
                    return true;
                }
                else
                 return false;
            }

        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = this.detail;
            newDetail.mode = this.$FORM_MODE_CREATE;
            newDetail.Is_show_Print = true;
            var det = { ...newDetail };

            this.header.Details.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.header.Details[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Details.splice(this.header.Details.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.header && this.header.Details) {
                let mode = this.header.Details[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Details[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        onFileRemove(files,data) {
                data.files_data = [];
                for(var i = 0; i<files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileRemove1(files,data) {
                data.files_data1 = [];
                for(var i = 0; i<files.length;i++){
                    data.files_data1.push(event.files[i]);
                }
        },
        onFileSelect(event, data) {
            data.files_data = [];
            for(var i = 0; i<event.files.length;i++){
                data.files_data.push(event.files[i]);
            }
        },
        onFileSelect1(event, data) {
            data.files_data1 = [];
            for(var i = 0; i<event.files.length;i++){
                data.files_data1.push(event.files[i]);
            }
        },
        onFileSelectUpload(event) {
            this.detailFiles = event.files;
            this.uploadFile = true;
        },
        
        onFileSelectClosing(event, data) {
            data.files_data1 = [];
            for(var i = 0; i<event.files.length;i++){
                data.files_data1.push(event.files[i]);
            }
        },
        onFileRemoveClosing(files,data) {
                data.files_data1 = [];
                for(var i = 0; i<files.length;i++){
                    data.files_data1.push(event.files[i]);
                }
        },
        onDownloadFileClosing(file){
            var self = this;
            this.$axios.get(this.url + "download_file/" + file.id + "/" + file.name, {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.name);
                    document.body.appendChild(link);
                    link.click();
                    
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    //self.showAssignModal = false;
                });
        },
        onDownloadFile1(file){
          
            var self = this;
            this.$axios.get(this.url + "download_currently/" + file.id + "/" + file.name, {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.name);
                    document.body.appendChild(link);
                    link.click();
                    
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    //self.showAssignModal = false;
                });
        },
        onDownloadFile2(file){
           
            var self = this;
            this.$axios.get(this.url + "download_previosly/" + file.id + "/" + file.name, {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.name);
                    document.body.appendChild(link);
                    link.click();
                    
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    //self.showAssignModal = false;
                });
        },
        onlyNumber ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                $event.preventDefault();
            }
        },
    },
    computed:{
        category(){
            var result = "";
            if (this.header.Department_Code == this.$DEPARTMENT.PROJECT && this.header.Work_Group == this.$WorkGroup.Project_Engineering)
                result = this.$CategoryWo.Execution;
            //if engineering update to execution
            else if (this.header.Department_Code == this.$DEPARTMENT.PROJECT && this.header.Work_Group == this.$WorkGroup.Project_Execution)
                result = this.$CategoryWo.Execution;
            else if (this.header.Department_Code == this.$DEPARTMENT.PROJECT && this.header.Work_Group == this.$WorkGroup.Project_Drafter)
                result = this.$CategoryWo.Drafter;
            else if (this.header.Department_Code == this.$DEPARTMENT.PROJECT && this.header.Work_Group == this.$WorkGroup.Project_Admin_Creator_AR)
                result = this.$CategoryWo.Admin_AR;
            else if (this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT && this.header.Work_Group == this.$WorkGroup.Project_Engineering)
                result = this.$CategoryWo.Engineering;
            else if (this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT && this.header.Work_Group == this.$WorkGroup.Project_Drafter)
                result = this.$CategoryWo.Drafter;
            else if (this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT && this.header.Work_Group == this.$WorkGroup.Project_Admin_Creator_AR)
                result = this.$CategoryWo.Admin_AR;

            return result;
        },
        is_lead_engineering(){
            var result = this.category == this.$CategoryWo.Execution && this.header.Department_Code == this.$DEPARTMENT.PROJECT ||
                        this.category == this.$CategoryWo.Engineering && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT;

            return result;
        },
        is_head_user(){
            var result = this.category == this.$CategoryWo.Drafter && this.header.Department_Code == this.$DEPARTMENT.PROJECT ||
                        this.category == this.$CategoryWo.Admin_AR && this.header.Department_Code == this.$DEPARTMENT.PROJECT ||
                        this.category == this.$CategoryWo.Drafter && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT ||
                        this.category == this.$CategoryWo.Admin_AR && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT ||
                        this.category == this.$CategoryWo.Engineering && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT;

            return result;
        },
        is_head_dept(){
            var result = this.category == this.$CategoryWo.Execution && this.header.Department_Code == this.$DEPARTMENT.PROJECT ||
                        this.category == this.$CategoryWo.Engineering && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT;

            return result;
        },
        is_pm_closing(){
            var result = this.category == this.$CategoryWo.Execution && this.header.Department_Code == this.$DEPARTMENT.PROJECT;

            return result;
        },
        is_pic_eng_closing(){
            var result = this.category == this.$CategoryWo.Engineering && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT;

            return result;
        },
        is_head_user_closing(){
            var result = this.category == this.$CategoryWo.Engineering && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT;

            return result;
        },
        is_head_dept_closing(){
            var result = this.category == this.$CategoryWo.Engineering && this.header.Department_Code == this.$DEPARTMENT.NON_PROJECT || 
                        this.category == this.$CategoryWo.Execution && this.header.Department_Code == this.$DEPARTMENT.PROJECT;

            return result;
        },

    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;
        this.mainid = this.$route.query.mainid ?? 0;
        if(this.$router.options.history.state.back != null){
            var indexName = this.$router.options.history.state.back.split("/");
            if(indexName[1] == "MainData")
            this.indexName = "MainDataIndex";
        }
        this.getData();
    }
}
</script>